var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { USER_INFO_ENDPOINT } from '../../constants';
export const fetchUserInfo = (emails, token) => __awaiter(void 0, void 0, void 0, function* () {
    return yield fetch(USER_INFO_ENDPOINT, {
        method: 'POST',
        body: JSON.stringify(emails),
        headers: {
            Authorization: token,
            'Content-Type': 'application/json',
        },
    });
});
//# sourceMappingURL=helpers.js.map